const translations = {
  signIn: "Sign in",
  googleLoginFailed: "Failed to login with Google",
};

export default translations;
